import React, { Suspense } from 'react'

import { BrowserRouter } from 'app/mainframe/context/history'
import { AppProviders } from 'app/mainframe/context/app'
import Routes from 'app/mainframe/Routes'

import { AiOutlineLoading } from 'react-icons/ai'

import 'shared/assets/styles/global.css'

const Mainframe = () => {
  return (
    <Suspense
      fallback={
        <div className='flex h-screen w-screen items-center justify-center'>
          <AiOutlineLoading className='flex animate-spin items-center justify-center text-2xl leading-none text-gray-50' />
        </div>
      }
    >
      <BrowserRouter>
        <AppProviders>
          <Routes />
        </AppProviders>
      </BrowserRouter>
    </Suspense>
  )
}

export default Mainframe
